import { AccountBalanceDto, AccountDto, BaseAccountDto } from 'src/dtos';
import {
  Account,
  AccountFinancialAssets,
  AccountHolderAddress,
  AccountStatus,
  AccountSuitabilityInformation,
  AccountType,
  BaseAccount,
  EntityAccountType,
  JointAccountType,
  RetirementAccountType,
} from 'src/models';
import { getUnitedStateOptionLabel } from 'src/utils';

import { mapAccountHolderDtoToModel } from './accountHolder.mapper';

export const mapBaseAccountDtoToModel = (dto: BaseAccountDto, balance?: AccountBalanceDto): BaseAccount => ({
  id: dto.id,
  accountId: dto.accountId,
  accountNumber: dto.accountNumber,
  status: new AccountStatus(dto.status),
  type: new AccountType(dto.type),
  primaryAccountHolder: dto.primaryAccountHolder && mapAccountHolderDtoToModel(dto.primaryAccountHolder),
  jointAccountType: dto.jointAccountType ? new JointAccountType(dto.jointAccountType) : undefined,
  retirementAccountType: dto.retirementAccountType ? new RetirementAccountType(dto.retirementAccountType) : undefined,
  entityAccountType: dto.entityAccountType ? new EntityAccountType(dto.entityAccountType) : undefined,
  cashBalance: balance?.cashBalance,
  createdAt: dto.createdAt,
});

export const mapAccountDtoToModel = (dto: AccountDto): Account => {
  const type = new AccountType(dto.type);

  let secondaryAccountHolder = dto.secondaryAccountHolder;

  if (type.isEntity && dto.otherAccountHolders && dto.otherAccountHolders.length > 0) {
    secondaryAccountHolder = dto.otherAccountHolders[0];
  }

  return {
    id: dto.id,
    createdAt: dto.createdAt,
    type: new AccountType(dto.type),
    jointAccountType: new JointAccountType(dto.jointAccountType),
    jointCommunityPropertyState: dto.jointCommunityPropertyState
      ? { label: getUnitedStateOptionLabel(dto.jointCommunityPropertyState), value: dto.jointCommunityPropertyState }
      : undefined,
    accountId: dto.accountId,
    accountNumber: dto.accountNumber,
    primaryAccountHolder: dto.primaryAccountHolder && mapAccountHolderDtoToModel(dto.primaryAccountHolder),
    secondaryAccountHolder: secondaryAccountHolder && mapAccountHolderDtoToModel(secondaryAccountHolder), // TODO: pass authroized signer 2 as secondary account holder if found in enttiy account
    retirementAccountType: dto.retirementAccountType ? new RetirementAccountType(dto.retirementAccountType) : undefined,
    simpleIraPlanName: dto.simpleIraPlanName,
    beneficiaryIraDecedentName: dto.beneficiaryIraDecedentName,
    beneficiaries: dto.beneficiaries ?? [],
    status: new AccountStatus(dto.status),
    entityAccountType: dto.entityAccountType ? new EntityAccountType(dto.entityAccountType) : undefined,
    entityInformation: dto.entityInformation
      ? { ...dto.entityInformation, address: new AccountHolderAddress(dto.entityInformation.address) }
      : undefined,
    applicationId: dto.applicationId,
    otherAccountHolders:
      dto.otherAccountHolders?.filter((holder, index) => index > 0).map(mapAccountHolderDtoToModel) ?? [],
    suitabilityInformation: dto.suitabilityInformation
      ? new AccountSuitabilityInformation(dto.suitabilityInformation)
      : undefined,
    financialAssets: dto.financialAssets ? new AccountFinancialAssets(dto.financialAssets) : undefined,
    isAccredited: dto.isAccredited ?? false,
  };
};
